// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-fe3b5af5] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.button-vue[data-v-fe3b5af5] {
  position: relative;
  width: fit-content;
  overflow: hidden;
  border: 0;
  padding: 0;
  font-size: var(--default-font-size);
  font-weight: 700;
  min-height: 44px;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 22px;
  transition-property:
    color,
    border-color,
    background-color;
  transition-duration: .1s;
  transition-timing-function: linear;
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
}
.button-vue *[data-v-fe3b5af5],
.button-vue span[data-v-fe3b5af5] {
  cursor: pointer;
}
.button-vue[data-v-fe3b5af5]:focus {
  outline: none;
}
.button-vue[data-v-fe3b5af5]:disabled {
  cursor: default;
  opacity: .5;
  filter: saturate(.7);
}
.button-vue:disabled *[data-v-fe3b5af5] {
  cursor: default;
}
.button-vue[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: var(--color-primary-element-light-hover);
}
.button-vue[data-v-fe3b5af5]:active {
  background-color: var(--color-primary-element-light);
}
.button-vue__wrapper[data-v-fe3b5af5] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.button-vue--end .button-vue__wrapper[data-v-fe3b5af5] {
  justify-content: end;
}
.button-vue--start .button-vue__wrapper[data-v-fe3b5af5] {
  justify-content: start;
}
.button-vue--reverse .button-vue__wrapper[data-v-fe3b5af5] {
  flex-direction: row-reverse;
}
.button-vue--reverse.button-vue--icon-and-text[data-v-fe3b5af5] {
  padding-inline: calc(var(--default-grid-baseline) * 4) var(--default-grid-baseline);
}
.button-vue__icon[data-v-fe3b5af5] {
  height: 44px;
  width: 44px;
  min-height: 44px;
  min-width: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-vue__text[data-v-fe3b5af5] {
  font-weight: 700;
  margin-bottom: 1px;
  padding: 2px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.button-vue--icon-only[data-v-fe3b5af5] {
  width: 44px !important;
}
.button-vue--text-only[data-v-fe3b5af5] {
  padding: 0 12px;
}
.button-vue--text-only .button-vue__text[data-v-fe3b5af5] {
  margin-left: 4px;
  margin-right: 4px;
}
.button-vue--icon-and-text[data-v-fe3b5af5] {
  padding-block: 0;
  padding-inline: var(--default-grid-baseline) calc(var(--default-grid-baseline) * 4);
}
.button-vue--wide[data-v-fe3b5af5] {
  width: 100%;
}
.button-vue[data-v-fe3b5af5]:focus-visible {
  outline: 2px solid var(--color-main-text) !important;
  box-shadow: 0 0 0 4px var(--color-main-background) !important;
}
.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-fe3b5af5] {
  outline: 2px solid var(--color-primary-element-text);
  border-radius: var(--border-radius);
  background-color: transparent;
}
.button-vue--vue-primary[data-v-fe3b5af5] {
  background-color: var(--color-primary-element);
  color: var(--color-primary-element-text);
}
.button-vue--vue-primary[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: var(--color-primary-element-hover);
}
.button-vue--vue-primary[data-v-fe3b5af5]:active {
  background-color: var(--color-primary-element);
}
.button-vue--vue-secondary[data-v-fe3b5af5] {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light);
}
.button-vue--vue-secondary[data-v-fe3b5af5]:hover:not(:disabled) {
  color: var(--color-primary-element-light-text);
  background-color: var(--color-primary-element-light-hover);
}
.button-vue--vue-tertiary[data-v-fe3b5af5] {
  color: var(--color-main-text);
  background-color: transparent;
}
.button-vue--vue-tertiary[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: var(--color-background-hover);
}
.button-vue--vue-tertiary-no-background[data-v-fe3b5af5] {
  color: var(--color-main-text);
  background-color: transparent;
}
.button-vue--vue-tertiary-no-background[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-fe3b5af5] {
  color: var(--color-primary-element-text);
  background-color: transparent;
}
.button-vue--vue-tertiary-on-primary[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: transparent;
}
.button-vue--vue-success[data-v-fe3b5af5] {
  background-color: var(--color-success);
  color: #fff;
}
.button-vue--vue-success[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: var(--color-success-hover);
}
.button-vue--vue-success[data-v-fe3b5af5]:active {
  background-color: var(--color-success);
}
.button-vue--vue-warning[data-v-fe3b5af5] {
  background-color: var(--color-warning);
  color: #fff;
}
.button-vue--vue-warning[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: var(--color-warning-hover);
}
.button-vue--vue-warning[data-v-fe3b5af5]:active {
  background-color: var(--color-warning);
}
.button-vue--vue-error[data-v-fe3b5af5] {
  background-color: var(--color-error);
  color: #fff;
}
.button-vue--vue-error[data-v-fe3b5af5]:hover:not(:disabled) {
  background-color: var(--color-error-hover);
}
.button-vue--vue-error[data-v-fe3b5af5]:active {
  background-color: var(--color-error);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcButton-DhaPcomf.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB;;;oBAGkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;;EAEE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mFAAmF;AACrF;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mFAAmF;AACrF;AACA;EACE,WAAW;AACb;AACA;EACE,oDAAoD;EACpD,6DAA6D;AAC/D;AACA;EACE,oDAAoD;EACpD,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,wCAAwC;AAC1C;AACA;EACE,oDAAoD;AACtD;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8CAA8C;EAC9C,oDAAoD;AACtD;AACA;EACE,8CAA8C;EAC9C,0DAA0D;AAC5D;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,+CAA+C;AACjD;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,sCAAsC;EACtC,WAAW;AACb;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,oCAAoC;AACtC","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-fe3b5af5] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.button-vue[data-v-fe3b5af5] {\n  position: relative;\n  width: fit-content;\n  overflow: hidden;\n  border: 0;\n  padding: 0;\n  font-size: var(--default-font-size);\n  font-weight: 700;\n  min-height: 44px;\n  min-width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 22px;\n  transition-property:\n    color,\n    border-color,\n    background-color;\n  transition-duration: .1s;\n  transition-timing-function: linear;\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n}\n.button-vue *[data-v-fe3b5af5],\n.button-vue span[data-v-fe3b5af5] {\n  cursor: pointer;\n}\n.button-vue[data-v-fe3b5af5]:focus {\n  outline: none;\n}\n.button-vue[data-v-fe3b5af5]:disabled {\n  cursor: default;\n  opacity: .5;\n  filter: saturate(.7);\n}\n.button-vue:disabled *[data-v-fe3b5af5] {\n  cursor: default;\n}\n.button-vue[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue[data-v-fe3b5af5]:active {\n  background-color: var(--color-primary-element-light);\n}\n.button-vue__wrapper[data-v-fe3b5af5] {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.button-vue--end .button-vue__wrapper[data-v-fe3b5af5] {\n  justify-content: end;\n}\n.button-vue--start .button-vue__wrapper[data-v-fe3b5af5] {\n  justify-content: start;\n}\n.button-vue--reverse .button-vue__wrapper[data-v-fe3b5af5] {\n  flex-direction: row-reverse;\n}\n.button-vue--reverse.button-vue--icon-and-text[data-v-fe3b5af5] {\n  padding-inline: calc(var(--default-grid-baseline) * 4) var(--default-grid-baseline);\n}\n.button-vue__icon[data-v-fe3b5af5] {\n  height: 44px;\n  width: 44px;\n  min-height: 44px;\n  min-width: 44px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.button-vue__text[data-v-fe3b5af5] {\n  font-weight: 700;\n  margin-bottom: 1px;\n  padding: 2px 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.button-vue--icon-only[data-v-fe3b5af5] {\n  width: 44px !important;\n}\n.button-vue--text-only[data-v-fe3b5af5] {\n  padding: 0 12px;\n}\n.button-vue--text-only .button-vue__text[data-v-fe3b5af5] {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.button-vue--icon-and-text[data-v-fe3b5af5] {\n  padding-block: 0;\n  padding-inline: var(--default-grid-baseline) calc(var(--default-grid-baseline) * 4);\n}\n.button-vue--wide[data-v-fe3b5af5] {\n  width: 100%;\n}\n.button-vue[data-v-fe3b5af5]:focus-visible {\n  outline: 2px solid var(--color-main-text) !important;\n  box-shadow: 0 0 0 4px var(--color-main-background) !important;\n}\n.button-vue:focus-visible.button-vue--vue-tertiary-on-primary[data-v-fe3b5af5] {\n  outline: 2px solid var(--color-primary-element-text);\n  border-radius: var(--border-radius);\n  background-color: transparent;\n}\n.button-vue--vue-primary[data-v-fe3b5af5] {\n  background-color: var(--color-primary-element);\n  color: var(--color-primary-element-text);\n}\n.button-vue--vue-primary[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: var(--color-primary-element-hover);\n}\n.button-vue--vue-primary[data-v-fe3b5af5]:active {\n  background-color: var(--color-primary-element);\n}\n.button-vue--vue-secondary[data-v-fe3b5af5] {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light);\n}\n.button-vue--vue-secondary[data-v-fe3b5af5]:hover:not(:disabled) {\n  color: var(--color-primary-element-light-text);\n  background-color: var(--color-primary-element-light-hover);\n}\n.button-vue--vue-tertiary[data-v-fe3b5af5] {\n  color: var(--color-main-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: var(--color-background-hover);\n}\n.button-vue--vue-tertiary-no-background[data-v-fe3b5af5] {\n  color: var(--color-main-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-no-background[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-fe3b5af5] {\n  color: var(--color-primary-element-text);\n  background-color: transparent;\n}\n.button-vue--vue-tertiary-on-primary[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: transparent;\n}\n.button-vue--vue-success[data-v-fe3b5af5] {\n  background-color: var(--color-success);\n  color: #fff;\n}\n.button-vue--vue-success[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: var(--color-success-hover);\n}\n.button-vue--vue-success[data-v-fe3b5af5]:active {\n  background-color: var(--color-success);\n}\n.button-vue--vue-warning[data-v-fe3b5af5] {\n  background-color: var(--color-warning);\n  color: #fff;\n}\n.button-vue--vue-warning[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: var(--color-warning-hover);\n}\n.button-vue--vue-warning[data-v-fe3b5af5]:active {\n  background-color: var(--color-warning);\n}\n.button-vue--vue-error[data-v-fe3b5af5] {\n  background-color: var(--color-error);\n  color: #fff;\n}\n.button-vue--vue-error[data-v-fe3b5af5]:hover:not(:disabled) {\n  background-color: var(--color-error-hover);\n}\n.button-vue--vue-error[data-v-fe3b5af5]:active {\n  background-color: var(--color-error);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
